import React from "react";

function AppFooter() {
  return (
    <footer className="has-bg-dark">
      <div className="container has-py-2">
        <p>
          <a href="https://github.com/vinceumo/qr-code-generator">See project on github</a>
        </p>
        <p>
          <a href="https://www.vincent-humeau.com">vincent-humeau.com</a>
        </p>
      </div>
    </footer>
  );
}

export default AppFooter;